import React from 'react';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToReservation = () => {
    document.getElementById('reservation-widget')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative h-screen w-full overflow-hidden" data-id="element-52">
      {/* Hero Image */}
      <div className="absolute inset-0" data-id="element-53">
        <img src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=2400&q=90" alt="Traditional Japanese izakaya interior with warm lighting" className="w-full h-full object-cover" data-id="element-54" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/95" data-id="element-55" />
      </div>

      {/* Hero Content */}
      <div className="relative h-full flex flex-col items-center justify-center text-center px-4 sm:px-6 lg:px-8" data-id="element-56">
        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-4 tracking-tight" data-id="element-57">
          Kumo Izakaya
        </h1>
        <p className="text-xl sm:text-2xl md:text-3xl text-amber-400 mb-8 font-light" data-id="element-58">
          Modern Japanese Dining in the Heart of the City
        </p>
        <p className="text-lg sm:text-xl text-gray-200 mb-12 max-w-2xl" data-id="element-59">
          Experience authentic izakaya cuisine with a contemporary twist. Fresh
          ingredients, bold flavors, unforgettable moments.
        </p>
        <button onClick={scrollToReservation} className="glow-button group text-black px-10 py-5 rounded-full text-lg font-semibold flex items-center gap-3 relative z-10" data-id="element-60">
          Reserve Your Table
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-61" />
        </button>
      </div>
    </section>;
}